// extracted by mini-css-extract-plugin
module.exports = {"icon":"OrderChecksIcon__icon____p9j0","stroked":"OrderChecksIcon__stroked___2G-4a","filled":"OrderChecksIcon__filled___B8G1h"};